import styled from 'styled-components'
import { Flex } from '@vtex/shoreline'

export const Container = styled(Flex)`
  padding: var(--sl-space-4);
  border-radius: var(--sl-radius-2);
  border: var(--sl-border-base);
  background: var(--sl-bg-base-soft);
`
